function validateBiggerThan(value, { min }) {
  const tmp = Number(value.toString().replace(/,/g, ".").replace(/\s+/g, ""));
  return typeof tmp === "number" && tmp > min;
}
function validateLowerOrEqual(value, { max }) {
  const tmp = Number(value.toString().replace(/,/g, ".").replace(/\s+/g, ""));
  return typeof tmp === "number" && tmp <= max;
}
function validateBiggerOrEqual(value, { min }) {
  const tmp = Number(value.toString().replace(/,/g, ".").replace(/\s+/g, ""));
  return typeof tmp === "number" && tmp >= min;
}
function validatePassword(password) {
  const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$!%*?&.,;:/]).{8,}$/;
  return regex.test(password);
}
function validateInArray(value, { array }) {
  return array.includes(value);
}
export {
  validateBiggerOrEqual,
  validateBiggerThan,
  validateInArray,
  validateLowerOrEqual,
  validatePassword
};
//# sourceMappingURL=validators.es.js.map
